import { MenuBookOutlined, MusicNoteOutlined, LibraryMusic, CoPresent, ExpandMore, YouTube, VolunteerActivism, SpeedOutlined, SettingsVoice } from '@mui/icons-material';
import { Paper, Divider, Button, AccordionSummary, Fade, Link } from '@mui/material';
import AccordionDetails, { accordionDetailsClasses } from '@mui/material/AccordionDetails';
import Accordion, { accordionClasses } from '@mui/material/Accordion';
import { Grid, IconButton, Typography } from '@material-ui/core';
import { practiseList, learnList, flashcardsList } from "../../AppHeaderMenu";
import { useNavigate } from 'react-router-dom';
import {useState} from 'react';
import './styles.css';
import SEO from '../../common/SEO';

const homePageData = [
	{
		courseCategory: 'Flashcards',
		description: "Not so confident reading musical notes? Improve this essential skill by practicing with this Flashcards tool! You can select which ranges of notes you wish to practice!",
		icon: <LibraryMusic style={{color: ' #ffffff'}} fontSize='large'/>,
		courseList: [...flashcardsList]
	},
	{
		courseCategory: 'SightPlay Challenge',
		description: "Can you read the notes and play them in tune? Take the SightPlay Challenge and test your violin skills — see how many notes you can get right!",
		icon: <SettingsVoice style={{color: ' #ffffff'}} fontSize='large'/>,
		courseList: [{name: "Let's go", url: '/pitch_tests'}]
	},
	{
		courseCategory: 'Learn',
		description: "Read and master left-hand finger patterns on the violin with visual guides and clear explanations in different keys in 1st and 3rd positions. Try using wider screen to enhance this learning experience!",
		icon: <MenuBookOutlined style={{color: ' #ffffff'}} fontSize='large'/>,
		courseList: [...learnList]
	},
	{
		courseCategory: 'Practice & Navigate',
		description: "Ready to level up your violin note-reading? Practice naming notes, matching them to the right string and finger, and navigate them on the visual fingerboard! Master 1st and 3rd positions in different keys!",
		icon: <MusicNoteOutlined style={{color: ' #ffffff'}} fontSize='large'/>,
		courseList: [...practiseList]
	},
	{
		courseCategory: 'Violin Tuner',
		description: "Use the EasyTune tool to help you tune your violin with sound and visual guidance!",
		icon: <SpeedOutlined style={{color: ' #ffffff'}} fontSize='large'/>,
		courseList: [{name: "Let's Go!", url: '/tune_violin'}]
	},
	{
		courseCategory: 'Video Learning',
		description: "Watch and play along with these video clips to help you set-up, learn, and practice all the essential practical skills to become a fantastic virtuoso!",
		icon: <YouTube style={{color: ' #ffffff'}} fontSize='large'/>,
		courseList: [{name: 'Coming Soon', url: '/'}]
	},
	{
		courseCategory: 'About & Contact',
		description: "Information about ViolinScope and its author, and how to contact us.",
		icon: <CoPresent style={{color: ' #ffffff'}} fontSize='large'/>,
		courseList: [{name: 'Find Out More', url: '/about'},]
	},
	{
		courseCategory: 'Donate',
		description: "If ViolinScope has been helpful, please consider making a donation to help maintaining and expanding this app. Any size of donation is greatly appreciated!",
		icon: <VolunteerActivism style={{color: ' #ffffff'}} fontSize='large'/>,
		courseList: [{name: "Buy me a coffee", url: '/'},]
	}

];

const homePageTestimonials = [
	"Help children learn violin and music theory through free, fun games that combine visual tools with audio feedback for faster progress",
	"Boost your child’s confidence by practicing sight-reading at home with interactive exercises that strengthen the visual–aural connection",
	// 'Free Visual Violin Learning Tools with Audio and Game-Based Practice',
	// 'Boost Sight-Reading, Knowledge and Intonation with Fun Challenges'
	// 'Free and fun online tools to help children learn to play violin visually and easily at home',
	// 'Fun games to boost reading skills and play music with more confidence',
	// 'Beginner friendly and progress faster by gaining insighful knowledge from a professional expert'
]

const HomePage = () => {
	let navigate = useNavigate();
	const [expandedItems, setExpandedItems] = useState([]);
	const [hoverCourseButton, setHoverCourseButton] = useState(null);

  const handleChange = (selectedPanel) => {
		const exist = expandedItems.some(item => item === selectedPanel);
		if(!!exist) {
			const filteredItems = expandedItems.filter(item => item !== selectedPanel)
			setExpandedItems(filteredItems)
		} else {
			setExpandedItems([...expandedItems, selectedPanel])
		}
  };

	return (
		<div style={{marginTop: '25px', marginBottom: '25px'} }>
			<SEO pageName="home" />
			{/* <Typography variant="h6" className='homePageText'>ViolinScope: Visual Violin Learning with Audio and Game-Based Practice to Boost Sight-Reading and Knowledge</Typography>	 */}
			{homePageTestimonials.map((sentence, id) => (
				<Typography variant="subtitle1" key={id} className='homePageText'>{`~ ${sentence} ~`}</Typography >	
			))}	
			<Grid container direction="row" spacing={6} justifyContent='space-around' style={{marginTop: '10px'}}>
			{homePageData.map(course => (
				<Grid item xs={12} sm={10} md={6} lg={5} key={course.courseCategory}>
					<Paper className="homePageWidgetPaper" style={{borderRadius: 10, backgroundImage:'linear-gradient(170deg, #08445e, #d1d1e0)', padding: 10, height: '100%'}}>
					<IconButton
						size="medium"
						sx={{ ml: 2 }}
						disabled
          >
          	{course.icon}
          </IconButton>
					<Typography variant='h6' className='textColor' >{course.courseCategory}</Typography>
					<Divider variant="middle" style={{borderColor: ' #ffffff', margin: '10px'}}/>
					<Typography variant='body1' className="textColor" style={{ padding: 10}}>{course.description}</Typography>
					{course.courseList.length <= 3 ?
						<Grid container spacing={2} style={{padding: 10}}>
							{course.courseCategory === "Donate" ?	
								<Grid item xs={12} md={course.courseList.length === 1 ? 12 : 6}  key={course.courseList[0].name}>
									<Link href="https://buymeacoffee.com/violinscope" target="_blank" rel="noopener noreferrer">
										<Button style={{textTransform: 'none', width: '70%'}} color='secondary' variant='contained'  onClick={() => null}>
											<img
												className="coffeeImage"
												src="https://cdn.buymeacoffee.com/buttons/bmc-new-btn-logo.svg"
												alt="Buy me a coffee"
											/>										
											<span className="coffeeButtonText">{course.courseList[0].name}</span>
											</Button>
									</Link>
								</Grid>
							:	
							course.courseList.map(item => (
								<Grid item xs={12} md={course.courseList.length === 1 ? 12 : 6}  key={item.name}> 
									<Button className="courseButtons" style={{textTransform: 'none'}} color='secondary' variant='contained'  onClick={() => navigate(item.url)}>{item.name}</Button>
								</Grid>
							)
							)}
						</Grid>
					:
						<Accordion
							expanded={!!expandedItems.some(item => item === course.courseCategory)}
							onChange={() => handleChange(course.courseCategory)}
							slots={{ transition: Fade }}
							slotProps={{ transition: { timeout: 1000 } }}
							sx={[
								!!expandedItems.some(item => item === course.courseCategory)
									? {
											[`& .${accordionClasses.region}`]: {
												height: 'auto',
											},
											[`& .${accordionDetailsClasses.root}`]: {
												display: 'block',
											},
										}
									: {
											[`& .${accordionClasses.region}`]: {
												height: 0,
											},
											[`& .${accordionDetailsClasses.root}`]: {
												display: 'none',
											},
										},
							]}
							style={{
								backgroundColor: !!expandedItems.some(item => item === course.courseCategory) ? 'transparent' : ' #9c27b0', 
								boxShadow: !!expandedItems.some(item => item === course.courseCategory) ? '2px 2px 4px #000000' : 'inherit'
							}}

						>
							<AccordionSummary
								expandIcon={<ExpandMore className="textColor"/>}
								aria-controls="panel1-content"
								id="panel1-header"
							>
								<Typography variant='body1' className="textColor" component="span">{!!expandedItems.some(item => item === course.courseCategory) ? 'View Less' : 'View Courses'}</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<Grid container spacing={2} style={{padding: 10}}>
									{course.courseList.map(item => (
										<Grid item xs={12} md={6}  key={item.name}> 
											<Button 
												className="courseButtons" 
												style={{
													textTransform: 'none', 
													backgroundColor: item.name.includes('3rd position') && hoverCourseButton === item.name ?  '#0c668d' : item.name.includes('3rd position') ? ' #0e77a4' : ''
												}} 
												color='secondary' 
												variant='contained'  
												onMouseEnter={() => setHoverCourseButton(item.name)}
												onMouseLeave={() => setHoverCourseButton(null)}
												onClick={() => navigate(item.url)}>
													{item.name}
											</Button>
										</Grid>
									))}
								</Grid>
							</AccordionDetails>
						</Accordion>
					}
					</Paper>
				</Grid>
			))}
			</Grid>
		</div>
	)
}

export default HomePage;